import Vue from "vue";
import Vuex from "vuex";
import * as auth from "@/store/modules/Auth";
import * as modules from "@/store/modules/modules";
import * as visModules from "@/store/modules/visModules";
import * as dateModules from "@/store/modules/dateModules";
import * as moduleA from "@/store/modules/moduleA";
import * as moduleB from "@/store/modules/moduleB";
import * as moduleC from "@/store/modules/moduleC";
import * as moduleD from "@/store/modules/moduleD";
import * as moduleE from "@/store/modules/moduleE";
import * as moduleF from "@/store/modules/moduleF";
import * as moduleG from "@/store/modules/moduleG";
import * as moduleH from "@/store/modules/moduleH";
import * as moduleI from "@/store/modules/moduleI";
import * as moduleJ from "@/store/modules/moduleJ";
import * as moduleK from "@/store/modules/moduleK";
import * as moduleL from "@/store/modules/moduleL";
import * as moduleM from "@/store/modules/moduleM";
import * as moduleN from "@/store/modules/moduleN";

import * as visA from "@/store/modules/visA";
import * as visB from "@/store/modules/visB";
import * as visC from "@/store/modules/visC";
import * as visD from "@/store/modules/visD";
import * as visE from "@/store/modules/visE";
import * as visF from "@/store/modules/visF";
import * as visG from "@/store/modules/visG";
import * as visH from "@/store/modules/visH";
import * as visI from "@/store/modules/visI";
import * as visJ from "@/store/modules/visJ";
import * as visK from "@/store/modules/visK";
import * as visL from "@/store/modules/visL";
import * as visM from "@/store/modules/visM";
import * as visN from "@/store/modules/visN";
Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    auth,
    modules,
    visModules,
    dateModules,
    visA,
    visB,
    visC,
    visD,
    visE,
    visF,
    visG,
    visH,
    visI,
    visJ,
    visK,
    visL,
    visM,
    visN,
    moduleA,
    moduleB,
    moduleC,
    moduleD,
    moduleE,
    moduleF,
    moduleG,
    moduleH,
    moduleI,
    moduleJ,
    moduleK,
    moduleL,
    moduleM,
    moduleN,
  },
});
